import { styled } from "@mui/material/styles";
import { DialogContent as MuiDialogContent } from "@mui/material";

export const DialogContent = styled(MuiDialogContent)({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "20px",
  overflow: "visible",
  paddingTop: 0,

  "& > .MuiFormControl-root, & > .MuiAutocomplete-root": {
    width: "45%",
  },
});
